var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2425 96H24V73.7575L68.635 29.1225C70.335 27.4225 72.595 26.4875 75 26.4875C77.405 26.4875 79.665 27.4225 81.365 29.1225L90.88 38.6375C92.58 40.3375 93.515 42.5975 93.515 45.0025C93.515 47.4075 92.58 49.6675 90.88 51.3675L46.245 96.0025L46.2425 96ZM30 90H43.7575L86.635 47.1225C87.2025 46.555 87.5125 45.8025 87.5125 45C87.5125 44.1975 87.2 43.445 86.635 42.8775L77.12 33.3625C76.5525 32.795 75.8 32.485 74.9975 32.485C74.195 32.485 73.4425 32.7975 72.875 33.3625L29.9975 76.24V89.9975L30 90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1206 39.8799L54.878 44.1225L72.8774 62.1219L77.12 57.8793L59.1206 39.8799Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1219 69.88L27.8793 74.1226L45.8787 92.122L50.1213 87.8794L32.1219 69.88Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.9c699ed5.svg";
export { ForwardRef as ReactComponent };